import Link from "next/link"

/** Related collection destinations retain readable boundaries in extracted text. */
export function CollectionSiblingLinks({ collections }: { collections: readonly { slug: string; title: string }[] }) {
  return (
    <div className="flex flex-wrap gap-2">
      {collections.map((c) => (
        <Link
          key={c.slug}
          href={`/collections/${c.slug}`}
          className="inline-flex min-h-11 items-center px-3.5 py-2 rounded-full bg-white border border-gray-200 text-[13.5px] font-semibold text-gray-700 hover:border-[#0469f0]/40 hover:text-[#0469f0] transition-colors"
        >
          {c.title}{' '}
        </Link>
      ))}
    </div>
  )
}
